/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type LoginDialogSignInMutationVariables = {
    email: string;
    password: string;
};
export type LoginDialogSignInMutationResponse = {
    readonly signIn: {
        readonly me: {
            readonly id: string;
            readonly name: string | null;
            readonly email: string | null;
            readonly picture: string | null;
            readonly username: string;
        } | null;
    } | null;
};
export type LoginDialogSignInMutation = {
    readonly response: LoginDialogSignInMutationResponse;
    readonly variables: LoginDialogSignInMutationVariables;
};



/*
mutation LoginDialogSignInMutation(
  $email: String!
  $password: String!
) {
  signIn(email: $email, password: $password) {
    me {
      id
      name
      email
      picture
      username
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "password"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "password",
        "variableName": "password"
      }
    ],
    "concreteType": "SignInPayload",
    "kind": "LinkedField",
    "name": "signIn",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "picture",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginDialogSignInMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginDialogSignInMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6f3f561b27f5924888aca92bdcff304b",
    "id": null,
    "metadata": {},
    "name": "LoginDialogSignInMutation",
    "operationKind": "mutation",
    "text": "mutation LoginDialogSignInMutation(\n  $email: String!\n  $password: String!\n) {\n  signIn(email: $email, password: $password) {\n    me {\n      id\n      name\n      email\n      picture\n      username\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '955c846637a0a33551b54262781fd03c';
export default node;
